import React, { useState, useEffect } from 'react';
import api from '../api';

export default function Register({ onBack }) {
  const [campuses, setCampuses] = useState([]);
  const [form, setForm] = useState({ full_name:'', email:'', password:'', confirm:'', campus_id:'' });
  const [err,  setErr]  = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [existing, setExisting] = useState(false);   // already-registered state
  const [resetSent, setResetSent] = useState(false);

  useEffect(() => { api.get('/auth/campuses').then(r => setCampuses(r.data)).catch(()=>{}); }, []);

  const submit = async e => {
    e.preventDefault();
    if (!form.full_name || !form.email || !form.password) { setErr('Fill all required fields'); return; }
    if (form.password.length < 6) { setErr('Password must be at least 6 characters'); return; }
    if (form.password !== form.confirm) { setErr('Passwords do not match'); return; }
    if (!form.campus_id) { setErr('Select your campus'); return; }
    setBusy(true); setErr('');
    try {
      await api.post('/auth/register', { full_name:form.full_name, email:form.email, password:form.password, campus_id:parseInt(form.campus_id) });
      setDone(true);
    } catch (ex) {
      if (ex.response?.status === 409 && ex.response?.data?.already_registered) {
        setExisting(true); setErr('');
      } else {
        setErr(ex.response?.data?.error || 'Registration failed');
      }
    }
    finally { setBusy(false); }
  };

  const requestReset = async () => {
    setBusy(true); setErr('');
    try {
      await api.post('/auth/forgot-password', { email: form.email });
      setResetSent(true);
    } catch (ex) { setErr(ex.response?.data?.error || 'Could not submit reset request'); }
    finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)',
      backgroundImage:'radial-gradient(ellipse at 20% 50%, rgba(79,142,247,0.08) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(167,139,250,0.06) 0%, transparent 60%)' }}>
      <div style={{ width:'100%', maxWidth:420, padding:24 }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ width:52, height:52, borderRadius:14, background:'var(--accent)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:24, margin:'0 auto 16px', boxShadow:'0 0 32px rgba(79,142,247,0.4)' }}>📝</div>
          <h1 style={{ fontSize:22, fontWeight:600, marginBottom:6 }}>Register for IT Support</h1>
          <p style={{ fontSize:13, color:'var(--text2)' }}>Create an account to raise IT tickets</p>
        </div>

        <div className="card" style={{ padding:24 }}>
          {existing ? (
            <div style={{ textAlign:'center', padding:'10px 0' }}>
              <div style={{ fontSize:38, marginBottom:10 }}>{resetSent ? '📨' : 'ℹ️'}</div>
              {resetSent ? (
                <>
                  <div style={{ fontWeight:600, marginBottom:8 }}>Reset request sent</div>
                  <p style={{ fontSize:13, color:'var(--text2)', lineHeight:1.6 }}>
                    A password reset request has been sent to the IT administrator. They will reset your password and share it with you. You'll be asked to set your own password on first login.
                  </p>
                </>
              ) : (
                <>
                  <div style={{ fontWeight:600, marginBottom:8 }}>You're already registered</div>
                  <p style={{ fontSize:13, color:'var(--text2)', lineHeight:1.6, marginBottom:16 }}>
                    You are already a registered user. Please set a new password or use the Forgot Password option to access your account.
                  </p>
                  {err && <div className="err-msg">{err}</div>}
                  <button className="btn btn-primary" disabled={busy}
                    style={{ width:'100%', justifyContent:'center', padding:'10px' }} onClick={requestReset}>
                    {busy ? 'Submitting…' : 'Forgot Password / Set New Password'}
                  </button>
                </>
              )}
              <button className="btn btn-secondary" style={{ width:'100%', justifyContent:'center', marginTop:10, padding:'10px' }} onClick={onBack}>Back to Sign In</button>
            </div>
          ) : done ? (
            <div style={{ textAlign:'center', padding:'10px 0' }}>
              <div style={{ fontSize:38, marginBottom:10 }}>✅</div>
              <div style={{ fontWeight:600, marginBottom:8 }}>Registration submitted</div>
              <p style={{ fontSize:13, color:'var(--text2)', lineHeight:1.6 }}>
                Your account is awaiting administrator approval. You'll be able to sign in with your email once approved.
              </p>
              <button className="btn btn-primary" style={{ width:'100%', justifyContent:'center', marginTop:18, padding:'10px' }} onClick={onBack}>Back to Sign In</button>
            </div>
          ) : (
            <form onSubmit={submit}>
              <div className="form-group">
                <label>Full Name *</label>
                <input value={form.full_name} autoFocus onChange={e => setForm(f => ({ ...f, full_name: e.target.value }))} placeholder="Your name" />
              </div>
              <div className="form-group">
                <label>Email * <span style={{ fontSize:11, color:'var(--text2)' }}>(this is your login)</span></label>
                <input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="you@school.edu" />
              </div>
              <div className="form-group">
                <label>Campus *</label>
                <select value={form.campus_id} onChange={e => setForm(f => ({ ...f, campus_id: e.target.value }))}>
                  <option value="">— Select your campus —</option>
                  {campuses.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Password *</label>
                  <input type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="Min 6 chars" />
                </div>
                <div className="form-group">
                  <label>Confirm *</label>
                  <input type="password" value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))} placeholder="Re-enter" />
                </div>
              </div>
              {err && <div className="err-msg">{err}</div>}
              <button type="submit" className="btn btn-primary" disabled={busy} style={{ width:'100%', justifyContent:'center', marginTop:12, padding:'10px' }}>
                {busy ? 'Submitting…' : 'Register'}
              </button>
            </form>
          )}
        </div>

        {!done && (
          <p style={{ textAlign:'center', fontSize:13, color:'var(--text2)', marginTop:16 }}>
            Already have an account?{' '}
            <span onClick={onBack} style={{ color:'var(--accent)', cursor:'pointer', fontWeight:500 }}>Sign In</span>
          </p>
        )}
      </div>
    </div>
  );
}
